<span
  [class]="getClasses()"
  [style]="{ maxWidth: maxWidth() }"
  role="status"
  ftrTooltip
  [message]="getTooltipLabel()"
  [forceDisplayState]="!!getTooltipLabel() ? undefined : 'hide'"
  [showDash]="false"
  [position]="tooltipPosition()"
  [attr.aria-label]="getAriaLabel()"
  [attr.aria-hidden]="ariaHidden()"
>
  @if (icon() && displayType() !== 'small') {
    <ftr-icon class="badge__icon" [icon]="icon()!" size="Text" [ariaHidden]="iconAriaHidden()" />
  }
  @if (text() && displayType() !== 'tile') {
    <span class="badge__text">{{ text() }}</span>
  }
</span>
